import './_jquery';
import dayjs from 'dayjs';
import 'dayjs/locale/it'
import {urlCacheBuster} from './_cache_buster';

dayjs.locale('it');

jQuery(function() {
  let loadFirstBox, loadSecondBox, loadThirdBox, loadView, loadViewMobile, mainPage, refreshPosts;

  if (window.location.pathname === '/') {
    mainPage = $('[data-newsevents-main-page]').data('newsevents-main-page');

    refreshPosts = function() {
      let data, events, eventsLimit, firstFilter, news, newsLimit, secondFilter, url;

      $('.component_news_and_events').animate({ opacity: 0.3 }, 300);

      news = $('[data-stock-news]').data('stock-news');
      events = $('[data-stock-events]').data('stock-events');
      firstFilter = $('[data-filter="sector"]').val();
      firstFilter = firstFilter ? firstFilter : 0;
      secondFilter = $('[data-filter="region"]').val();
      secondFilter = secondFilter ? secondFilter : 0;
      newsLimit = 4;
      eventsLimit = 3;

      url = new String;
      url = url.concat(
        "/wp-json/api/v1/posts/news_events?",
        "filters=" + firstFilter + "," + secondFilter,
        "&news_limit=" + newsLimit,
        "&events_lmit=" + eventsLimit,
        "&news=" + news,
        "&events=" + events
      );

      data = {
        "async": true,
        "crossDomain": true,
        "url": url,
        "method": "GET",
        "headers": {}
      };

      $.ajax(data).done(function(response) {
        $('.component_news_and_events').animate({ opacity: 1 }, 300);

        if (window.innerWidth < 768) {
          $('[data-type="component_news_and_events--desk"]').remove();
          loadViewMobile(response);
        } else {
          $('[data-type="component_news_and_events--mobile"]').remove();
          loadView(response);
        }
      });
    };

    loadView = function(data) {
      let events, firstBoxNews, news, secondBoxNews;

      news = data['news'];
      events = data['events'];
      secondBoxNews = news.splice(1);
      firstBoxNews = news[0];
      loadFirstBox(firstBoxNews);
      loadSecondBox(secondBoxNews);
      loadThirdBox(events);
    };

    loadViewMobile = function(data) {
      let events, news;

      news = data['news'];
      events = data['events'];
      loadSecondBox(news);
      loadThirdBox(events, true);
    };

    loadFirstBox = function(data) {
      let ellipsis, term, term_slug, truncatedText, truncatedTitle;

      $("[data-newsevents-gridbox='first-image']").css({
        'background-image': 'url("' + urlCacheBuster(data['image']) + '")'
      });

      if (data['label_name']) {
        term = data['label_name'];
        term_slug = data['label_slug'];
      } else {
        term = data['term'] ? data['term'] : 'News';
        term_slug = data['term_slug'];
      }

      $("[data-newsevents-gridbox='first-term']").html(term);
      $("[data-newsevents-gridbox='first-term-link']").attr('href', mainPage + term_slug);

      truncatedTitle = data['title'];
      ellipsis = ' ...';
      if (data['title'].length > 200) {
        truncatedTitle = data['title'].substring(0, 200 - ellipsis.length) + ellipsis;
      }
      $("[data-newsevents-gridbox='first-title']").html(truncatedTitle);

      // Bug 13830 Non stampare il sottotitolo se titolo > 110 battute
      if (data['title'].length < 110) {
        truncatedText = data['text'].substring(0, 150);
        if (truncatedText.length < data['text'].length) {
          truncatedText = truncatedText + ' ...';
        }
        $("[data-newsevents-gridbox='first-text']").html(truncatedText);
      }

      $("[data-newsevents-gridbox='first-date']").text(data['date']);
      $("[data-newsevents-gridbox='first-cta']").attr('href', data['link']);
    };

    loadSecondBox = function(data) {
      let i, index, len, post, term, term_slug, truncatedTitle;

      for (index = i = 0, len = data.length; i < len; index = ++i) {
        post = data[index];
        truncatedTitle = post['title'].substring(0, 70);

        if (truncatedTitle.length < post['title'].length) {
          truncatedTitle = truncatedTitle + ' ...';
        }

        $("[data-newsevents-gridbox='second-image-" + index + "']").css({
          'background-image': 'url("' + urlCacheBuster(post['image']) + '")'
        });

        if (post['label_name']) {
          term = post['label_name'];
          term_slug = post['label_slug'];
        } else {
          term = post['term'] ? post['term'] : 'News';
          term_slug = post['term_slug'];
        }

        $("[data-newsevents-gridbox='second-term-" + index + "']").html(term);
        $("[data-newsevents-gridbox='second-term-link-" + index + "']").attr('href', mainPage + term_slug);
        $("[data-newsevents-gridbox='second-title-" + index + "']").html(truncatedTitle);
        $("[data-newsevents-gridbox='second-date-" + index + "']").text(post['date']);
        $("[data-newsevents-gridbox='second-cta-" + index + "']").attr('href', post['link']);
      }
    };

    loadThirdBox = function(data, isMobile) {
      let charsLimit, date, i, index, len, months, post, term, truncatedText;

      // IE11 fix
      if (isMobile === null || isMobile === undefined || isMobile === void 0) {
        isMobile = false;
      }

      months = ['GEN', 'FEB', 'MAR', 'APR', 'MAG', 'GIU', 'LUG', 'AGO', 'SET', 'OTT', 'NOV', 'DIC'];
      for (index = i = 0, len = data.length; i < len; index = ++i) {
        post = data[index];

        $("[data-newsevents-gridbox='third-image-" + index + "']").css({
          'background-image': 'url("' + urlCacheBuster(post['image']) + '")'
        });

        charsLimit = isMobile ? 55 : 70;
        truncatedText = post['title'].substring(0, charsLimit);

        if (truncatedText.length < post['title'].length) {
          truncatedText = truncatedText + '...';
        }

        $("[data-newsevents-gridbox='third-title-" + index + "']").html(truncatedText);

        if (post['label_name']) {
          term = post['label_name'];
        } else {
          term = post['term'];
        }

        $("[data-newsevents-gridbox='third-term-" + index + "']").html(term);
        $("[data-newsevents-gridbox='third-cta-" + index + "']").attr('href', post['link']);
        date = dayjs(post['event_details']['event_date']).format('DD MMM');
        $("[data-newsevents-gridbox='third-date-box-" + index + "']").html(date);
      }
    };

    refreshPosts();

    $('[data-filter="sector"]').on('change', function() {
      $(this).css('font-weight', 600);
      refreshPosts();
    });

    $('[data-filter="region"]').on('change', function() {
      $(this).css('font-weight', 600);
      refreshPosts();
    });
  }
});
